import { z } from 'zod';
export const transactionSourceSchema = z.enum(['manual', 'csv', 'pdf', 'api']);
export const createTransactionSchema = z.object({
    locationId: z.string().uuid().optional(),
    categoryId: z.string().uuid().optional(),
    date: z.coerce.date(),
    amount: z.number(),
    description: z.string().min(1).max(1000),
    vendor: z.string().max(255).optional(),
    notes: z.string().max(2000).optional(),
});
export const updateTransactionSchema = z.object({
    locationId: z.string().uuid().optional().nullable(),
    categoryId: z.string().uuid().optional().nullable(),
    date: z.coerce.date().optional(),
    amount: z.number().optional(),
    description: z.string().min(1).max(1000).optional(),
    vendor: z.string().max(255).optional().nullable(),
    notes: z.string().max(2000).optional().nullable(),
    isReconciled: z.boolean().optional(),
    categoryConfirmed: z.boolean().optional(),
});
export const transactionFilterSchema = z.object({
    locationId: z.string().uuid().optional(),
    categoryId: z.string().uuid().optional(),
    startDate: z.coerce.date().optional(),
    endDate: z.coerce.date().optional(),
    source: transactionSourceSchema.optional(),
    minAmount: z.number().optional(),
    maxAmount: z.number().optional(),
    search: z.string().optional(),
    isReconciled: z.boolean().optional(),
    needsReview: z.boolean().optional(),
    page: z.number().min(1).default(1),
    pageSize: z.number().min(1).max(100).default(20),
});
export const createCategorySchema = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/)
        .optional(),
    icon: z.string().max(50).optional(),
    parentId: z.string().uuid().optional(),
});
export const updateCategorySchema = z.object({
    name: z.string().min(1).max(100).optional(),
    description: z.string().max(500).optional().nullable(),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/)
        .optional()
        .nullable(),
    icon: z.string().max(50).optional().nullable(),
    parentId: z.string().uuid().optional().nullable(),
});
//# sourceMappingURL=transaction.js.map